module.exports = __webpack_public_path__ + "img/Windows_2.1eb7ccd4.png";